export default __webpack_public_path__ + "locales/de/Translations.json?hash=e78b73c0747624491b9ba26a5c05dee8";